export enum MskScoreVersion {
    V0, // Original MSK Score. We have a different report for this
    V1, // MSK Score with responses.
    V2 // MSK Score with Pain Areas and Scales instead of Pain Severity
}